<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:error="errorHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import DomesticInquiryForm from "../../../components/industrialrelations/domesticinquiry/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": DomesticInquiryForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle:this.$t('ircasemaintenance.dimaintenancenew'),
      pageTitleValue: "",
      formData: {
        ircaseid: null,
        incidentdate: null,
        shortdesc: null,
        longdesc: null,
        staffid: null,
        sessiondesc: null,
        ditime: null,
        didate: null,
        venueid: null,
        panelmemberdetail: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
      },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      this.$store.dispatch('post', {url: "/irdomesticinquiry/create", payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "domesticinquirylist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

  

    cancelHandler() {
      this.$router.push({ name: "domesticinquirylist" });
    },
  },
};
</script>